import React from 'react';

const Hospital = (
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: 'inherit' }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 1a1 1 0 0 1 1-1h13.85a1 1 0 0 1 1 1v23H0V1Zm4.53 12h6.79v10H4.53V13Zm0-2.753H6.07V7.273h3.706v2.98h1.542v-7.43H9.777v2.964H6.071V2.818H4.53v7.43Zm11.83-4.792h6.636a1 1 0 0 1 1 1v17.546h-7.637V5.454Zm1.09 2.181h2.181v2.182h-2.182V7.636Zm5.454 0h-2.181v2.182h2.181V7.636Zm-2.181 3.273h2.181v2.182h-2.181v-2.182Zm-1.092 0h-2.182v2.182h2.182v-2.182Zm-2.182 3.273h2.182v2.181h-2.182v-2.181Zm5.455 0h-2.181v2.181h2.181v-2.181Z"
      style={{ fill: 'inherit' }}
    />
  </svg>
);

export default Hospital;
